/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SandboxProvider = {
  InMemory: "in-memory",
  RunnerProcess: "runner-process",
  RunnerDocker: "runner-docker",
  RunnerFirecracker: "runner-firecracker",
} as const;
export type SandboxProvider = ClosedEnum<typeof SandboxProvider>;

/** @internal */
export const SandboxProvider$inboundSchema: z.ZodNativeEnum<
  typeof SandboxProvider
> = z.nativeEnum(SandboxProvider);
/** @internal */
export const SandboxProvider$outboundSchema: z.ZodNativeEnum<
  typeof SandboxProvider
> = SandboxProvider$inboundSchema;
